export default function LegalTerms() {
  return (
    <div class='w-[70%] mx-auto bg-white p-8 rounded-lg mt-[100px] md:mt-[128px] flex flex-row justify-between items-start'>
      <div class='bg-termsBg py-8 rounded-lg hidden sm:block w-[100%]'>
        <p class='text-gray-500 mb-6 px-4'>Table of content</p>
        <div className='p-4 bg-termsHeaderBg'>
          <h1 class='text-xl font-semibold text-gray-800'>Terms of Service</h1>
        </div>
        <ul class='list-decimal list-inside text-gray-700 my-6 pl-4'>
          <li class='mb-2'>
            <a href='#tos-introduction' class='pl-4 hover:underline'>
              Introduction
            </a>
          </li>
          <li class='mb-2'>
            <a href='#tos-eligibility' class='pl-4 hover:underline'>
              Eligibility
            </a>
          </li>
          <li class='mb-2'>
            <a href='#tos-service-description' class='pl-4 hover:underline'>
              Service Description
            </a>
          </li>
          <li class='mb-2'>
            <a href='#tos-account-security' class='pl-4 hover:underline'>
              Account and Security
            </a>
          </li>
          <li class='mb-2'>
            <a href='#tos-privacy' class='pl-4 hover:underline'>
              Privacy
            </a>
          </li>
          <li class='mb-2'>
            <a href='#tos-fees' class='pl-4 hover:underline'>
              Fees
            </a>
          </li>
          <li class='mb-2'>
            <a href='#tos-transaction-limits' class='pl-4 hover:underline'>
              Transaction Limits
            </a>
          </li>
        </ul>

        <div className='p-4 bg-termsHeaderBg'>
          <h1 class='text-xl font-semibold text-gray-800'>
            Apple Pay Terms and Conditions
          </h1>
        </div>
        <ul class='list-decimal list-inside my-6 text-gray-700 px-4'>
          <li class='mb-2'>
            <a href='#applepay-introduction' class='pl-4 hover:underline'>
              Introduction
            </a>
          </li>
          <li class='mb-2'>
            <a href='#applepay-eligibility' class='pl-4 hover:underline'>
              Eligibility
            </a>
          </li>
          <li class='mb-2'>
            <a
              href='#applepay-service-description'
              class='pl-4 hover:underline'
            >
              Service Description
            </a>
          </li>
          <li class='mb-2'>
            <a href='#applepay-account-security' class='pl-4 hover:underline'>
              Account and Security
            </a>
          </li>
          <li class='mb-2'>
            <a href='#applepay-privacy' class='pl-4 hover:underline'>
              Privacy
            </a>
          </li>
          <li class='mb-2'>
            <a href='#applepay-fees' class='pl-4 hover:underline'>
              Fees
            </a>
          </li>
          <li class='mb-2'>
            <a href='#applepay-transaction-limits' class='pl-4 hover:underline'>
              Transaction Limits
            </a>
          </li>
          <li class='mb-2'>
            <a
              href='#applepay-merchant-relationships'
              class='pl-4 hover:underline'
            >
              Merchant Relationships
            </a>
          </li>
          <li class='mb-2'>
            <a href='#applepay-user-conduct' class='pl-4 hover:underline'>
              User Conduct
            </a>
          </li>
          <li class='mb-2'>
            <a
              href='#applepay-intellectual-property'
              class='pl-2 hover:underline'
            >
              Intellectual Property
            </a>
          </li>
          <li class='mb-2'>
            <a href='#applepay-termination' class='pl-2 hover:underline'>
              Termination
            </a>
          </li>
          <li class='mb-2'>
            <a
              href='#applepay-disclaimers-liability'
              class='pl-2 hover:underline'
            >
              Disclaimers and Limitation of Liability
            </a>
          </li>
          <li class='mb-2'>
            <a
              href='#applepay-disclaimers-liability'
              class='pl-2 hover:underline'
            >
              Governing Law
            </a>
          </li>
          <li class='mb-2'>
            <a
              href='#applepay-disclaimers-liability'
              class='pl-2 hover:underline'
            >
              Changes To erms
            </a>
          </li>
          <li class='mb-2'>
            <a
              href='#applepay-disclaimers-liability'
              class='pl-2 hover:underline'
            >
              Contact Information
            </a>
          </li>
        </ul>
      </div>
      <div class='bg-white px-8 rounded-lg'>
        <h1 class='text-3xl font-bold text-gray-800 mb-4'>Terms of Service</h1>
        <p class='text-gray-600 mb-2'>Published date: 3rd July 2024</p>
        <p class='text-gray-600 mb-6'>Effective date: 3rd July 2024</p>

        <h2
          class='text-xl font-semibold text-gray-800 mb-2'
          id='tos-introduction'
        >
          1. Introduction
        </h2>
        <p class='text-gray-700 mb-4'>
          These Terms and Conditions ("<strong>Terms</strong>") govern your use
          of the Cypher Non-Custodial Wallet and Crypto Card services ("
          <strong>Services</strong>") provided by Cypher Technologies Inc. ("
          <strong>Cypher</strong>", "<strong>we</strong>", "<strong>us</strong>"
          or "<strong>our</strong>"). By using our Services, you agree to comply
          with these Terms.
        </p>

        <h2
          class='text-xl font-semibold text-gray-800 mb-2'
          id='tos-eligibility'
        >
          2. Eligibility
        </h2>
        <p class='text-gray-700 mb-4'>To use our Services, you must:</p>
        <ul class='list-disc list-inside text-gray-700 mb-4'>
          <li>
            Be at least 18 years old (or the age of majority in your
            jurisdiction).
          </li>
          <li>Have a compatible device and a valid Cypher account.</li>
          <li>
            Comply with all applicable laws and regulations related to
            cryptocurrency use in your jurisdiction.
          </li>
        </ul>

        <h2
          class='text-xl font-semibold text-gray-800 mb-2'
          id='tos-service-description'
        >
          3. Service Description
        </h2>
        <p class='text-gray-700 mb-4'>
          Cypher provides a Non-Custodial Wallet that allows you to store,
          manage, and transact with cryptocurrencies, and a Crypto Card for
          making purchases. As a non-custodial service, you retain full control
          over your private keys and funds.
        </p>

        <h2
          class='text-xl font-semibold text-gray-800 mb-2'
          id='tos-account-security'
        >
          4. Account and Security
        </h2>
        <p class='text-gray-700 mb-4'>
          You are responsible for maintaining the confidentiality of your
          account information and any credentials associated with your use of
          our Services. Notify us immediately of any unauthorized use or
          security breach.
        </p>

        <h2 class='text-xl font-semibold text-gray-800 mb-2' id='tos-privacy'>
          5. Privacy
        </h2>
        <p class='text-gray-700 mb-4'>
          Your privacy is important to us. Our Privacy Policy explains how we
          collect, use, and protect your information when you use our Services.
        </p>

        <h2 class='text-xl font-semibold text-gray-800 mb-2'>6. Fees</h2>
        <p class='text-gray-700 mb-4'>
          We may charge fees for certain transactions or services. Details of
          our fees are available on our website and within the app. Your bank or
          card issuer may also impose fees related to transactions made using
          the Crypto Card. Check with your financial institution for details.
        </p>

        <h2
          class='text-xl font-semibold text-gray-800 mb-2'
          id='tos-transaction-limits'
        >
          7. Transaction Limits
        </h2>
        <p class='text-gray-700 mb-6'>
          Transaction limits may apply depending on our policies, your account
          status, and the merchant's acceptance criteria. These limits will be
          communicated to you within the app.
        </p>

        <h1 class='text-3xl font-bold text-gray-800 mt-16 mb-4'>
          Apple Pay Terms and Conditions
        </h1>

        <h2
          class='text-xl font-semibold text-gray-800 mb-2'
          id='applepay-introduction'
        >
          1. Introduction
        </h2>
        <p class='text-gray-700 mb-4'>
          These Apple Pay Terms and Conditions ("<strong>Terms</strong>") govern
          your use of Apple Pay ("<strong>Service</strong>") provided by Apple
          Inc. ("<strong>Apple</strong>", "<strong>we</strong>", "
          <strong>us</strong>", or "<strong>our</strong>"). By using Apple Pay,
          you agree to comply with these Terms.
        </p>

        <h2
          class='text-xl font-semibold text-gray-800 mb-2'
          id='applepay-eligibility'
        >
          2. Eligibility
        </h2>
        <p class='text-gray-700 mb-4'>
          To use Apple Pay, you must: Be at least 18 years old (or the age of
          majority in your jurisdiction). Have a compatible Apple device and a
          valid Apple ID. Have a participating credit or debit card issued by a
          supported financial institution.
        </p>

        <h2
          class='text-xl font-semibold text-gray-800 mb-2'
          id='applepay-service-description'
        >
          3. Service Description
        </h2>
        <p class='text-gray-700 mb-4'>
          Apple Pay allows you to make payments using eligible Apple devices at
          participating merchants and within apps. Apple Pay utilizes near-field
          communication (NFC) technology and other security features to process
          transactions.
        </p>

        <h2
          class='text-xl font-semibold text-gray-800 mb-2'
          id='applepay-account-security'
        >
          4. Account and Security
        </h2>
        <p class='text-gray-700 mb-4'>
          You are responsible for maintaining the confidentiality of your Apple
          ID and any credentials associated with your use of Apple Pay. Notify
          us immediately of any unauthorized use or security breach.
        </p>

        <h2
          class='text-xl font-semibold text-gray-800 mb-2'
          id='applepay-privacy'
        >
          5. Privacy
        </h2>
        <p class='text-gray-700 mb-4'>
          Your privacy is important to us. Our Privacy Policy explains how we
          collect, use, and protect your information when you use Apple Pay.
        </p>

        <h2 class='text-xl font-semibold text-gray-800 mb-2'>6. Fees</h2>
        <p class='text-gray-700 mb-4'>
          Apple does not charge a fee for using Apple Pay. However, your bank or
          card issuer may impose fees related to transactions made using Apple
          Pay. Check with your financial institution for details.
        </p>

        <h2
          class='text-xl font-semibold text-gray-800 mb-2'
          id='applepay-transaction-limits'
        >
          7. Transaction Limits
        </h2>
        <p class='text-gray-700 mb-4'>
          Transaction limits may apply depending on your bank or card issuer's
          policies and the merchant's acceptance criteria.
        </p>

        <h2
          class='text-xl font-semibold text-gray-800 mb-2'
          id='applepay-merchant-relationships'
        >
          8. Merchant Relationships
        </h2>
        <p class='text-gray-700 mb-4'>
          Apple Pay is a payment service provider and is not responsible for the
          goods or services you purchase using Apple Pay. Any disputes regarding
          products or services purchased must be resolved with the merchant.
        </p>

        <h2
          class='text-xl font-semibold text-gray-800 mb-2'
          id='applepay-user-conduct'
        >
          9. User Conduct
        </h2>
        <p class='text-gray-700 mb-4'>
          You agree not to: Use Apple Pay for any illegal or unauthorized
          purposes. Interfere with or disrupt the operation of Apple Pay or the
          servers or networks connected to the Service. Misrepresent your
          identity or affiliation with any person or entity.
        </p>

        <h2
          class='text-xl font-semibold text-gray-800 mb-2'
          id='applepay-intellectual property'
        >
          10. Intellectual Property
        </h2>
        <p class='text-gray-700 mb-4'>
          Apple Pay and all related intellectual property are the property of
          Apple Inc. You are granted a limited, non-exclusive, non-transferable
          license to use Apple Pay in accordance with these Terms.
        </p>

        <h2
          class='text-xl font-semibold text-gray-800 mb-2'
          id='applepay-termination'
        >
          11. Termination
        </h2>
        <p class='text-gray-700 mb-4'>
          We reserve the right to suspend or terminate your access to Apple Pay
          at any time, with or without notice, for any reason, including if we
          believe you have violated these Terms.
        </p>

        <h2
          class='text-xl font-semibold text-gray-800 mb-2'
          id='applepay-disclaimers-liability'
        >
          12. Disclaimers and Limitation of Liability
        </h2>
        <p class='text-gray-700 mb-4'>
          Apple Pay is provided on an "as-is" and "as-available" basis. We do
          not warrant that the Service will be uninterrupted or error-free. To
          the fullest extent permitted by law, Apple disclaims all warranties,
          express or implied, and shall not be liable for any indirect,
          incidental, special, or consequential damages arising out of your use
          of Apple Pay.
        </p>

        <h2
          class='text-xl font-semibold text-gray-800 mb-2'
          id='applepay-governing-law'
        >
          13. Governing Law
        </h2>
        <p class='text-gray-700 mb-4'>
          These Terms are governed by and construed in accordance with the laws
          of the State of California, without regard to its conflict of law
          principles.
        </p>

        <h2
          class='text-xl font-semibold text-gray-800 mb-2'
          id='applepay-changes-terms'
        >
          14. Changes to Terms
        </h2>
        <p class='text-gray-700 mb-4'>
          We may update these Terms from time to time. Any changes will be
          posted on our website and will be effective upon posting. Your
          continued use of Apple Pay after the posting of changes constitutes
          your acceptance of such changes.
        </p>

        <h2
          class='text-xl font-semibold text-gray-800 mb-2'
          id='applepay-contact-information'
        >
          15. Contact Information
        </h2>
        <p class='text-gray-700'>
          If you have any questions or concerns about these Terms or Apple Pay,
          please contact Apple Support. By using Apple Pay, you acknowledge that
          you have read, understood, and agreed to these Terms and Conditions.
        </p>
      </div>
    </div>
  );
}
